module.exports = __webpack_public_path__ + "img/cju_main0.c249aee1.jpg";